import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pop-error-wrapper',
  templateUrl: './error-wrapper.component.html',
  styleUrls: ['./error-wrapper.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorWrapperComponent {}
